interface SelectLocationProps {
  selectedLocation: DefaultLocation[];
  setSelectedLocation: (value: DefaultLocation[]) => void;
}

function SelectLocation({
    selectedLocation,
    setSelectedLocation,
}: SelectLocationProps) {
  const locationsList: DefaultLocation[] = ['Hong Kong', 'London', 'Mumbai', 'New York'];

  return (
    <div className='flex lg:flex-col space-y-2 w-2/3 lg:w-auto'>
      <div className='flex space-x-2 lg:space-x-4 items-center'>
          {locationsList.map((location) => (
            <LocationItem
              key={location}
              location={location}
              selectedLocation={selectedLocation}
              setSelectedLocation={setSelectedLocation}
            />
          ))}
      </div>
    </div>
  );
}

interface LocationItemProps {
  location: DefaultLocation;
  selectedLocation: DefaultLocation[];
  setSelectedLocation: (value: DefaultLocation[]) => void;
}
const LocationItem = ({
  location,
  selectedLocation,
  setSelectedLocation,
}: LocationItemProps) => {
  return (
    <div className='flex items-center'>
      <label className='text-[12px] lg:text-[13px] flex items-center'>
        <input
          disabled={
            selectedLocation.includes(location) && selectedLocation.length <= 1
          }
          type='checkbox'
          value={location}
          checked={selectedLocation.includes(location)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedLocation([...selectedLocation, location]);
            } else {
              setSelectedLocation(
                selectedLocation.filter((item) => item !== location)
              );
            }
          }}
          className='mx-1 h-[15px] w-[15px] cursor-pointer'
        />
        {location}
      </label>
    </div>
  );
};

export default SelectLocation;